import { put, call } from 'redux-saga/effects';
import { receiveField } from '../actions/fieldActions';
import { requestField } from '../requesters/fieldRequester';

/**
 * Calls the requester to get field data
 * @param {String} fieldId
 * @return {void}
 */
export function* getField(fieldId) {
  const response = yield call(requestField, fieldId);
  yield put(receiveField(response));
  return {
    fieldUUID: response.uuid,
    fieldOwnerId: response.userId,
  };
}
